import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DomainList from "../views/DomainList";
import Login from "../views/Login";
import Store from '../store'
import config from '../config'
import ToDoList from "../views/ToDoList";
import PageNotFound from "../views/PageNotFound";
import FileList from "../views/FileList";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/domain/list/:page?',
        name: 'domain_list',
        component: DomainList
    },
    {
        path: '/todo/list/:page?',
        name: 'todo_list',
        component: ToDoList
    },
    {
        path: '/file/list/:page?',
        name: 'file_list',
        component: FileList
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '*',
        name: 'page_not_found',
        component: PageNotFound
    },
];

let router_option = {
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
};
if(config.MODE && config.MODE!=='') router_option.mode = config.MODE;
const router = new VueRouter(router_option);

router.beforeEach((to,from,next)=>{
    let public_routes = ['login','register-','home','domain_list-'];

    if( public_routes.indexOf(to.name.toString())===-1 ){
        if(Store.state.authenticated) {
            next()
        }else{
            next({ replace: true, name: 'login' } );
        }
    }else{
        next()
    }
});

export default router
